export default /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/